/**
 * Returns true when a visible react-bootstrap modal is open above the form modal.
 */
export function hasVisibleBootstrapModalOpen() {
  const modals = document.querySelectorAll('.modal.show');
  for (const modal of modals) {
    const style = window.getComputedStyle(modal);
    if (style.display === 'none' || style.visibility === 'hidden') continue;
    return true;
  }
  return false;
}

/**
 * React onKeyDown handler for modal shells — closes via the same callback as Cancel / X.
 */
export function createModalEscapeKeyDownHandler(onClose) {
  return (event) => {
    if (event.key !== 'Escape' && event.keyCode !== 27) return;
    if (hasVisibleBootstrapModalOpen()) return;
    event.preventDefault();
    event.stopPropagation();
    onClose?.();
  };
}

/**
 * Document/window listener used by useFocusTrap and full-page forms.
 */
export function handleGlobalModalEscape(event, onClose) {
  if (event.key !== 'Escape' && event.keyCode !== 27) return false;
  if (hasVisibleBootstrapModalOpen()) return false;
  if (!onClose) return false;
  event.preventDefault();
  event.stopPropagation();
  onClose();
  return true;
}
